import { User } from "@/types/users"
import { formatCoins } from "../../util/format"

export type Supporter = {
  avatar: Partial<User>
  lastTx: number
  percentage: string
  type: "LIKED" | "LOVED" | "BELIEVER"
}

export async function sellCoins(
  amount: number
): Promise<{ coins: string; usdValue: string }> {
  return testPromise({
    coins: formatCoins(amount),
    usdValue: (Math.random() * 1e-10 * 2500 * amount).toFixed(2),
  })
}

function testPromise<T>(returnValue: T, failRate = 0.5): Promise<T> {
  const fail = Math.random() < failRate
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (fail) reject("TEST ERROR")
      else resolve(returnValue)
    }, 1_000)
  })
}
